//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { INFO_GRAPHIC_COLORS } from "@/constants/ui.js";
import { v4 as uuidv4 } from 'uuid';
import GradientChoice from './GradientChoice.vue';
import '@/plugins/tooltip.js'

export default {
  name: "ColorChoice",
  components: { GradientChoice },
  props: {
    color: {
      type: String,
    },
    offset: {
      type: Number,
    },
    withOffset: {
      type: Boolean,
      default: false
    },
    requiredColor: {
      type: Boolean,
      default: true
    },
    tooltip: {
      type: String,
      default: 'Цвет'
    },
    iconName: {
      type: String,
      default: 'styles-picker'
    },
    palette: {
      type: [String, null],
      default: null
    },
    isPalette: {
      type: Boolean,
      default: false
    },
    gradient_enabled: {
      type: Boolean,
      default: false
    },
    gradient_direction: {
      type: [String, null],
      default: null
    },
    gradient_shadow_direction: {
      type: [String, null],
      default: null
    },
    isGradient: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    INFO_GRAPHIC_COLORS() {
      return INFO_GRAPHIC_COLORS
    },
    palete() {
      if (!this.color) return
      return new Array(6).fill(null).map((x, index) => {
        return {
          color: this.modifyHexColor(this.color, this.offset + (index * 10)),
          key: uuidv4()
        }
      })
    },
    paletteList() {
      const palette = this.$store.state["property_templates"]["consts"].palette;

      return palette ?? null;
    },
    paletteItem() {
      const palette = this.$store.state["property_templates"]["consts"].palette;
      if (palette) {
        return palette.filter(el => el.id === this.palette)[0];
      }

      return null;
    },
  },
  methods: {
    setColor(val) {
      this.deletePalette();
      this.$emit('update:offset', 0)
      if (this.color === val) {
        this.$emit('update:color', null)
      } else {
        this.$emit('update:color', val)
      }
    },
    modifyHexColor(hexColor, offset) {
      // Парсим HEX цвет в RGB компоненты
      const red = parseInt(hexColor.slice(1, 3), 16);
      const green = parseInt(hexColor.slice(3, 5), 16);
      const blue = parseInt(hexColor.slice(5, 7), 16);

      // Изменяем каналы, но не выходя за границы 0 и 255
      const newRed = Math.min(Math.max(red + offset, 0), 255);
      const newGreen = Math.min(Math.max(green + offset, 0), 255);
      const newBlue = Math.min(Math.max(blue + offset, 0), 255);

      // Преобразуем новые значения обратно в HEX формат
      const modifiedColor = `#${newRed.toString(16).padStart(2, '0')}${newGreen.toString(16).padStart(2, '0')}${newBlue.toString(16).padStart(2, '0')}`;

      return modifiedColor;
    },
    changePalete(direction = 'up') {
      switch (direction) {
      case "up":
        this.$emit('update:offset', Math.min(Math.max(this.offset + 10, -255), 255))
        break
      case "down":
        this.$emit('update:offset', Math.min(Math.max(this.offset - 10, -255), 255))
        break
      default:
        break
      }
    },
    resetAll() {
      this.$emit('update:color', null);
      this.$emit('update:palette', null);
      this.$emit('update:gradient_direction', null);
      this.$emit('update:gradient_shadow_direction', null);
    },
    deletePalette() {
      this.$emit('update:palette', null);
    },
    onChangePalette(e) {
      this.$emit('update:color', null)
      this.$emit('update:palette', e.target.value);
    },
    onChangeGradientShadowDirection(e) {
      this.$emit('update:gradient_shadow_direction', e.target.value);
    },
    onChangeGradientDirection(e) {
      this.$emit('update:gradient_direction', e.target.value);
    },
  }
}
